import { differenceInMilliseconds } from "date-fns";

/**
 * @param timeline
 * @param date
 * @param id
 * @returns number
 */
export const getTimelineOffset = (timeline, date) => {
    const timelineLength = differenceInMilliseconds(timeline.end, timeline.start);
    const dateOffset = differenceInMilliseconds(date, timeline.start)

    return dateOffset / timelineLength * 100;
}
